<template>
  <div class="bottom h-[220px]">
    <div class="bottom-content">
      <Resource :src="bgUrl" />
      <div class="bottom-content-inner">
        <div class="text-[24px] leading-[36px] font-semibold mt-[16px] text-white">
          {{ title }}
        </div>
        <div class="text-[16px] leading-[24px] mt-[10px] text-[var(--back-bg-80)]">
          {{ desc }}
        </div>
        <a-button
          class="w-[216px] h-[44px] mt-[24px] text-[14px] rounded-[8px] flex-y-center justify-center bg-[var(--text-1)] text-white hover:!bg-[var(--text-1-80)]"
          type="primary"
          @click="contactUs"
        >
          {{ $t('lian-xi-wo-men') }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { PageKey } from '~/constants/page';
import { showContact, showDynamicContact } from '~/hooks/useModal/modals/contact';

const props = defineProps<{ title: string; desc: string; trackParams?: any }>();

const bgUrl = transformImage(getFeUrl('/youyan-platform/png/case/case-bottom-bg.png'));

const resourceLocation = injectResourceLocation();

const route = useRoute();

function contactUs() {
  trackEvent(TRACK_EVENT.CLICK_CONTACT_US, {
    source: resourceLocation?.source,
    ...props.trackParams,
  });

  switch (route.name) {
    case PageKey.CASE:
      showDynamicContact(PositionCode['有言官网学院-客户案例-合作伙伴']);
      break;
    case PageKey.INDUSTRY_DETAIL:
      showContact('yygw-sy-ghydb-llwm');
      break;
    default:
      showContact();
  }
}
</script>
<style lang="scss" scoped>
.bottom {
  @apply bg-back-1 mb-[100px];

  .bottom-content {
    @apply relative w-full h-full mx-auto rounded-[12px] overflow-hidden;

    img {
      @apply h-full w-full object-cover;
    }

    .bottom-content-inner {
      @apply flex flex-col items-center justify-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full;
    }
  }
}
</style>
